import React, { isValidElement, useMemo } from 'react';
export const useSortedElements = ({
  children,
  elements,
  searchString
}) => {
  const sortedElements = useMemo(() => {
    if (!searchString) {
      return elements;
    }
    const onlyOptions = elements.filter(element => element.type === 'OPTION' && element.id !== 'UNDEFINED');
    const firstMatchOfSearchString = string => {
      return string.toLowerCase().indexOf(searchString.toLowerCase());
    };
    return onlyOptions.sort((a, b) => firstMatchOfSearchString(a.label) - firstMatchOfSearchString(b.label));
  }, [elements, searchString]);
  const childrenArray = useMemo(() => {
    const reactChildrenArray = React.Children.toArray(children);
    if (!searchString) {
      return reactChildrenArray;
    }
    return sortedElements.map(element => reactChildrenArray.find(reactChild => /*#__PURE__*/isValidElement(reactChild) && (reactChild.key === `.$${element?.id}` || reactChild.key === `.${element?.id}`))).filter(Boolean);
  }, [children, searchString, sortedElements]);
  return {
    reactElements: childrenArray,
    elements: sortedElements
  };
};